<template>
  <div class="col">
    <label class="form-label">사원번호</label>
    <div class="p-autocomplete-wrap p-autocomplete-car-driver">
      <AutoComplete
          v-model="selectedCarDriverIpt"
          :suggestions="filteredCarDriverList"
          @blur="handleCarDriverBlur"
          @item-select="handleItemSelect"
          @complete="filterCarDrivers"
          @show="handleDropdownShow"
          @focus="handleFocus"
          dropdown
          emptySearchMessage="검색 결과가 없습니다."
      />
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {allCarDriverOpt, searchBarProps} from "@/store/searchbar";

const emit = defineEmits(['loading']);
const props = defineProps({
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const carDriverInOfficeMap = computed(() => store.state.searchBar.carDriverInOfficeMap);
const carDriverInPeriodList = computed(() => store.state.searchBar.carDriverInPeriodList);
const settings = computed(() => store.state.searchBar.settings);
const selectedOffice = computed(() => store.state.searchBar.selectedOffice);
const selectedCarDriver = computed(() => store.state.searchBar.selectedCarDriver);
const carDriverList = computed(() => {
  if (settings.value.autoSelectDriver) {
    return carDriverInPeriodList.value;
  }

  if (!selectedOffice.value || !carDriverInOfficeMap.value[selectedOffice.value.id]) {
    return [];
  }

  return carDriverInOfficeMap.value[selectedOffice.value.id];
});
const selectedCarDriverIpt = ref(selectedCarDriver.value);
const filteredCarDriverList = ref([]);


// Methods
function filterCarDrivers(event) {
  const query = event.query.toLowerCase();
  filteredCarDriverList.value = carDriverList.value.filter(item =>
      item.toLowerCase().includes(query)
  );
}

function handleCarDriverBlur() {
  if (!selectedCarDriverIpt.value || selectedCarDriverIpt.value.length !== 4) {
    selectedCarDriverIpt.value = settings.value.autoSelectDriver
      ? null
      : allCarDriverOpt;

    patchSearchBar({
      prop: searchBarProps.selectedCarDriver,
      value: allCarDriverOpt,
    });
  } else if (selectedCarDriverIpt.value.length === 4 || selectedCarDriver.value !== selectedCarDriverIpt.value) {
    patchSearchBar({
      prop: searchBarProps.selectedCarDriver,
      value: selectedCarDriverIpt.value,
    });
  }
}

function handleDropdownShow(evt) {
  const targetEl = window.document.querySelector('.p-autocomplete-items .p-highlight')
  if (targetEl) {
    targetEl.scrollIntoView({block: 'center'});
  }
}

function handleItemSelect({value}) {
  patchSearchBar({
    prop: searchBarProps.selectedCarDriver,
    value,
  });
}

function handleFocus() {
  if (selectedCarDriverIpt.value === allCarDriverOpt) {
    selectedCarDriverIpt.value = null;
  }
}

watch(
    selectedCarDriver,
    (after, _) => {
      if (selectedCarDriverIpt.value === after) {
        return;
      }

      selectedCarDriverIpt.value = after;
    }
);

</script>

<style>
.p-autocomplete-car-driver .p-autocomplete .p-autocomplete-input {
  width: 115px;
}
</style>
